import { Injectable, Inject } from '@angular/core';
import { AuthHttp } from 'angular2-jwt';
import { APIBase } from './api.base';
import { Router } from '@angular/router';
import { SessionStorageService } from '../services/session-storage.service';

@Injectable()
export class HonorariosParcelasAPI extends APIBase {

	constructor(@Inject(AuthHttp) authHttp: AuthHttp, @Inject(Router) router: Router, @Inject(SessionStorageService) session: SessionStorageService) {
		super(authHttp, router, session);

		// Entidade principal
		this.__entity = 'honorarios_parcelas';
	}
			/**
	 * get parcelas by propostaID
	 *
	 *
	 * @access public
	 * @author Nicolas Aoki
	 * @since  11/2019
	 * @param  object
	 * @return object Promise
	 */
	public getByPropostaId(data) {
		let dados = {
			PropostaId:data
		};
		return this._call(this.__entity, dados , 'get');        
	}
		/**
	 * save
	 *
	 * Salva os dados
	 *
	 * @access public
	 * @author Nicolas Aoki
	 * @since  01/2020
	 * @param  object
	 * @return object Promise
	 */
	public save(parcelas) {
        // return this._call(this.__entity + '/save', data);
		return this._call(this.__entity + '/save', {parcelas} , 'post');
	}
	/**
	 * delete
	 *
	 * deleta parcela 
	 *
	 * @access public
	 * @author Nicolas Aoki
	 * @since  01/2020
	 * @param  object
	 * @return object Promise
	 */
	public delete(parcela?,propostaId?) {
		return this._call(this.__entity + '/delete', {parcela,PropostaId:propostaId} , 'post');
	}
	
}


// WEBPACK FOOTER //
// ./src/api/honorarios_parcelas.api.ts